import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login/login";
import Landing from "./Landing/landingpage";
import AdminLogin from "./Login/adminLogin";
import AdminDashboard from "./Dashboard/adminDashboard";
import ProtectedRoute from "./components/protectedRoute";
import ProtectedRouteCompany from "./components/protectedRouteCompany";
import CompanyDashboard from "./Dashboard/companyDashboard";
import BewerbenPage from "./components/bewerbung";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Landing />} />
        <Route path="/adminLogin" element={<AdminLogin />} />
        <Route path="/bewerben/:subdomain" element={<BewerbenPage />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRouteCompany>
              <CompanyDashboard />
            </ProtectedRouteCompany>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
